import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminGrants from "@/pages/AdminGrants";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/grants")({
  head: () => seoHead("/admin/grants"),
  component: () => (
    <AdminGate><AdminGrants /></AdminGate>
  ),
});
